import { createFileRoute } from "@tanstack/react-router";
import { buildSeo } from "@/lib/seo";
import { useTranslation } from "react-i18next";
import { MarketingLayout, SectionHeader, I18nPageHero } from "@/components/marketing/Layout";

export const Route = createFileRoute("/careers")({
 head: () => buildSeo({
 path: "/careers",
 title: "Careers — Reality Twin (Ruznic Marketing)",
 description: "Reality Twin is publicly available. We're not hiring broadly, but we'd love to hear from exceptional engineers, designers and operators in Switzerland.",
 }),
 component: CareersPage,
});

function CareersPage() {
 const { t } = useTranslation();
 const values = t("routes.careers.values", { returnObjects: true }) as { title: string; desc: string }[];
 return (
 <MarketingLayout>
 <I18nPageHero tKey="pages.careers" />

 <section className="border-b border-border py-16">
 <div className="mx-auto max-w-3xl px-6 space-y-5 text-[16px] leading-[1.7] text-muted-foreground">
 <p>
 {t("routes.careers.p1Pre")}
 <a href="https://ruznic-marketing.com" className="underline text-foreground">{t("routes.careers.p1Link")}</a>
 {t("routes.careers.p1Post")}
 </p>
 <p>{t("routes.careers.p2")}</p>
 <p className="text-foreground">
 {t("routes.careers.p3Pre")}<a href="mailto:hello@realitytwin.io" className="underline">hello@realitytwin.io</a>{t("routes.careers.p3Post")}
 </p>
 </div>
 </section>

 <section className="py-20">
 <div className="mx-auto max-w-6xl px-6">
 <SectionHeader eyebrow={t("routes.careers.valuesEyebrow")} title={<>{t("routes.careers.valuesTitleA")}<em className="italic text-muted-foreground">{t("routes.careers.valuesTitleEm")}</em></>} />
 <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-px bg-border hairline rounded-xl overflow-hidden">
 {values.map((v) => (
 <div key={v.title} className="bg-card p-7">
 <h3 className="font-serif text-[22px] leading-tight">{v.title}</h3>
 <p className="mt-2 text-[14px] leading-relaxed text-muted-foreground">{v.desc}</p>
 </div>
 ))}
 </div>
 </div>
 </section>
 </MarketingLayout>
 );
}
